<template>
<div>
  <section class="registerbox " >
    <div class="formHeader" style="height:50px;line-height:50px;background:	#333">
      <div style="float:left; padding-top:7px;">
        <h5 class="title is-5" style="color:#fff;padding-left:10px;margin-top:5px"><b>Client List</b></h5>
      </div>

      <div align="right" style="padding:10px;">
        <a class="is-link" v-on:click="seen = !seen" id="addsearchbuttons">
          <span v-on:click="useradd()" v-if="seen = seen" class="button is-small is-info" style="padding:10px;height:35px;font-size:15px;margin-top:-3px;background:#B0C4DE;color:#000;margin-right:10px">Add New </span>
        </a>
      </div>

    </div>
    <div class="box" v-if="seen">
      <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">

        <div class="field is-horizontal">
          <div class="field-label is-normal" style="margin-right: 23px;">
            <label class="label">Client Name</label>
          </div>
          <div class="field-body" align="left">
            <div class="field">
              <input class="input" v-on:keyup="clear1" type="text" v-model="client.name" name="client name" placeholder="Enter Client Name"
                style="width:347px">
            </div>
            <div class="field-label is-normal">
              <label class="label" style="width:138px;">Client ID</label>
            </div>
            <div class="field">
              <p class="control" style="width: 354px;">
                <input class="input" type="text" v-model="client.id" name="client id" placeholder="Enter Client ID">
              </p>
            </div>

          </div>

        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal" style="margin-right: 23px;">
            <label class="label">Client Code</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input class="input" v-on:keyup="clear1" type="text" v-model="client.code" name="client code" placeholder="Enter Client Code"
                  style="width:347px">
              </p>
            </div>
            <div class="field-label is-normal">
              <label class="label" style="width: 138px;">Client Country</label>
            </div>

            <div class="field">
              <div class="" style="width: 350px;">
                <select name="location type" v-model="client.country" :class="{'input': true, 'is-danger': errors.has('form-1.client country') }" style="margin-left:-0px;">
                                        <option :value="selected">--Select Country--</option>
                                        <option value="dubai">Dubai</option>
                                    </select>

              </div>

            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">State</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control" style="width: 350px;">
                <select v-model="client.state" name="state" :class="{'input': true, 'is-danger': errors.has('form-1.state') }">
                                        <option :value="selected">--Select--</option>
                                        <option v-for="state in states">{{state}}</option>
                                    </select>
              </p>
            </div>
            <div class="field-label is-normal">
              <label class="label" style="width:138px;">City</label>
            </div>
            <div class="field">
              <p class="control" style="width: 354px;">
                <input class="input" type="text" v-model="client.city" name="city"  placeholder="Enter City Name">
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label ">
            <label class="label">IsActive</label>
          </div>
          <div class="field-body" align="left">
            <div class="field">
              <div class="field">
                <div class="select" style="width: 350px;">
                  <select name="isactive" v-model="client.isactive" :class="{'input': true, 'is-danger': errors.has('form-1.isactive') }">
                                          <option :value="selected">--Select--</option>
                                          <option value="1">Active</option>
                                          <option value="0">InActive</option>
                                      </select>
                </div>
              </div>

            </div>
          </div>
        </div>
        <footer class="column has-text-right">
          <button class="button is-info" type="submit">Search</button>
          <button class="button is-primary" type="button" @click="clear" style="background:#778899">Clear</button>
        </footer>
      </form>
    </div>
  </section>

  <div class="table-responsive" style="margin:0px 20px">
    <input type="hidden" name="isactiveId" id="isactiveId" value="">
    <input type="hidden" name="clientmasterId" id="clientmasterId" value="">
    <table class="table table-striped table-bordered" border="1" >
      <thead>
        <tr>
          <th>Client Name</th>
          <th>Client ID</th>
          <th>Client Code</th>
          <th>Country</th>
          <th>State</th>
          <th>City</th>
          <!-- <th>Location Type</th>
          <th>Verification Code</th> -->
          <!-- <th>Change Verification Code</th> -->
          <th>IsActive</th>
          <th>Created Date</th>
          <th>Last Modified Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="value in data">
          <td><router-link v-bind:to="'/clientOnboard/' + value.clientmasterid+'/edit'">{{ value.clientname }}</router-link></a></td>
          <td>{{ value.clientid }}</td>
          <td>{{ value.clientcode }}</td>
          <td>{{ value.clientcountry }}</td>
          <td>{{ value.clientstate }}</td>
          <td>{{ value.clientcity }}</td>
          <!-- <td>{{ value.pickuplocationtype }}</td> -->
          <!-- <td>{{ value.verificationcode }}</td> -->
          <!-- <td>
            <button href="" class="editbtn" data-toggle="tooltip" title="Change Verification Code" @click="changeVerificationCodeModal(value)"><i class="fa fa-check-square" style="#444"></i></button>
          </td> -->
          <td>
            <button class="editbtn" @click="toggleInfoModal(value)" style="width: 74px; cursor:pointer;">
               <span data-toggle="tooltip" title="InActive" v-if="value.isactive ==='0'" style="color:red"> <i class="fa fa-times"></i></span>  <span data-toggle="tooltip" title="Active" v-else style="color:green"><i class="fa fa-check"></i></span>
             </button>
          </td>
          <td style="width: 100px;">{{ value.createddate | datechange }}</td>
          <td style="width: 100px;">{{ value.lastmodifieddate | datechange }}</td>
        </tr>
      </tbody>
    </table>

  </div>
  <div class="modal" :class="{'is-active' : toggleInfo}">
    <form v-on:submit.prevent="activateInActivateClient(value)">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirmation Box</p>
          <button class="delete" type="button" @click="toggleInfoModal(false)"></button>
        </header>
        <section class="modal-card-body">
          <input type="hidden" v-model="client.isactive" name="isactive" id="modalIsActiveChk">
          <span>Are you sure you want to change the status?</span>
        </section>
        <footer class="modal-card-foot" style="padding-left:568px">
          <button class="button is-success" type="submit">Ok</button>
        </footer>
      </div>
    </form>
  </div>

</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Router from 'vue-router'
import clientOnboard from '@/components/clientOnboard'
export default {
  data: function() {
    return {
      name: 'pickuplocation',
      data: [],
      clientdata: [],
      customerSearch: {},
      seen: true,
      toggleInfo: false,
      verificationCodeToggleInfo: false,
      client: {
        // pickuplocationcountry: 'Dubai'
      },
       states: [
        'Abu Dhabi',
        'Al Ain',
        'Ajman',
        'Dubai',
        'Fujairah',
        'Ras Al Khaimah',
        'Sharjah',
        'Umm Al Quwain'
      ] 
    }
  },
  created: function() {
  //  this.displaydata()
  this.displayclient()
  },
  methods: {
    validateForm(scope) {

      //this.customer.pickuplonglat = this.longitude + ',' + this.latitude
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.displaydata(this.client)
        }
      })
    },
    clear1: function() {},
    searchclear: function() {
      this.customerSearch = {}
      this.errors.clear('form-2')
    },
    getPickupLocationById: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      if (this.$route.params.id) {
        const obj = {
          lastmodifiedby: `${userInfo.sysemailid}`,
          pickuplocationmasterid: this.$route.params.id
        }
        this.$http
          .post(`${CONSTANTS.API_URL}/PickUpLocationMasterGet`, obj)
          .then(result => {
            this.customer = result.body[0]
          })
          .catch(ex => {
            console.log('error', ex)
          })
      }
    },
    validateForm2: function(scope) {
      this.displaydata(JSON.stringify(this.customerSearch))
    },
    useradd:function(){
      this.$router.push('/clientOnboard');
    },
    displaydata: function(serchData) {
      const customerGetAllobj = serchData || {}
      this.$http
        .post(
          `${CONSTANTS.API_URL}/ClientMasterGet`,
            customerGetAllobj
        )
        .then(result => {
          if (
            (result.body[0].returnmsg &&
              result.body[0].returnmsg === 'UnSuccessful') ||
            result.body[0].returnmsg === 'No Records Founnd'
          ) {
            alert('Result not found')
          } else {
            this.data = result.body
          }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    },
    edituser: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.errors.clear('form-1')
      this.seen = true
      this.customer = JSON.parse(JSON.stringify(value))
      var latLogArray = value.pickuplonglat.split(',')
      this.longitude = latLogArray[0] || 0
      this.latitude = latLogArray[1] || 0
    },
    clear: function() {
      this.client = {}
      this.errors.clear('form-1');
      this.displayclient();
    },
    displayclient: function() {
      this.$http
        .post(`${CONSTANTS.API_URL}/ClientMasterGet`)
        .then(result => {
          this.data = result.body
        })
        .catch(ex => {
          alert(ex)
        })
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.changeVerificationCode()
        }
      })
    },
    changeVerificationCode: function() {
        var result = []
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        // var passwObj = {
        //   deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        //   deliveryagentpassword: `${this.customer.deliveryagentpassword}`,
        //   lastmodifiedby: `${userInfo.sysemailid}`
        // }
        // if (typeof this.customer.deliveryagentmasterid !== 'undefined') {
        //   this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster/ChangePassword`, passwObj)
        //     .then((result) => {
        //       alert('Password updated successfully')
        //       this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo
        //       this.customer = {}
        //       this.displaydata()
        //     })
        //     .catch((ex) => {
        //       console.log('error', ex)
        //     })
        // }
    },
    toggleInfoModal: function(value) {
      //debugger
      this.client = value
      if (value.isactive === '1') {
        //this.customer.isactive = true
      } else {
        //this.customer.isactive = false
      }
      if (value !== undefined) {
        document.getElementById('clientmasterId').value = value.clientmasterid
        document.getElementById('isactiveId').value = value.isactive
      }

      this.toggleInfo = !this.toggleInfo
    },
    activateInActivateClient: function(value) {
      var clientmasterId = document.getElementById('clientmasterId').value
      var activeInactiveVal
      if (this.client.isactive === '1') {
        activeInactiveVal = '0'
      } else {
        activeInactiveVal = '1'
      }
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const customerGetobj = {
        clientmasterId: clientmasterId,
        isactive: activeInactiveVal,
        lastmodifiedby: `${userInfo.sysemailid}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/ActivateInActivateClient`, customerGetobj)
        .then((result) => {
          this.toggleInfo = false
          this.displaydata()
          //location.reload()
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      this.displaydata()
      alert('Status changed successfully')
    }
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>

<style lang="css">
.table tr th{
  color:#fff!important;
}

.table button{
  background:	#B0C4DE!important;
  color:#000!important;
}
.table tr:hover{
  background:#efefef;
}
tbody tr:nth-child(even) {background: #f2f2f2}
tbody tr:nth-child(odd) {background: #FFF}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #F7F7F7;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn{
  border:none;
  background:transparent!important;
}
</style>
